import { createFileRoute } from "@tanstack/react-router";
import { SupportSettingsPage } from "@charphq/ui/components/layout/pages/SupportSettingsPage";

export const Route = createFileRoute("/support_/settings")({
  component: SupportSettingsPage,
});
